var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('div',[_c('div',{staticClass:"text-center d-flex flex-column h-100 justify-content-between"},[_c('font-awesome-icon',{staticClass:"id-icon",attrs:{"icon":['fas', _vm.icon]}}),_c('div',{staticClass:"id-text"},[_vm._v(_vm._s(_vm.$t(`idTags.${_vm.id}`)))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }